import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Progress } from 'next-common-lib';

export const ProgressPopup = ({ zIndex }) => {
  const isShow = useSelector(state => state.popup.ProgressPopup.isShow);
  const getTop = () => {
    return `calc(50% + ${window.scrollY}px)`;
  };

  return (
    <>
      {isShow && (
        <Modal isDimed dimedClassName="dimmed-progress" style={{ zIndex: 2500 }} top={getTop()}>
          <div style={{ width: 100 }}>
            <Progress componentType="loading" zIndex={zIndex} />
          </div>
        </Modal>
      )}
    </>
  );
};

ProgressPopup.propTypes = {
  zIndex: PropTypes.number,
};
ProgressPopup.defaultProps = {
  zIndex: 5000,
};

export default ProgressPopup;
